import apiService from '../utils/apiService';

import {
  ADD_BRAND,
  ADD_BRAND_ERROR,
  ADD_BRAND_START,
  UPDATE_BRAND,
  UPDATE_BRAND_ERROR,
  UPDATE_BRAND_START,
  GET_BRAND,
  GET_BRAND_ERROR,
  GET_BRAND_START,
  GET_BRAND_LIST_PAGEABLE,
  GET_BRAND_LIST_PAGEABLE_START,
  GET_BRAND_LIST_PAGEABLE_ERROR,
  DELETE_BRAND,
  DELETE_BRAND_ERROR,
  DELETE_BRAND_START,
  CLEAR_ERROR_BRAND,
  GET_BRAND_LIST,
  GET_BRAND_LIST_ERROR,
  GET_BRAND_LIST_START,
} from './types';

import {
  brandAddPath,
  brandUpdatePath,
  brandFindAllPath,
  brandFindByIdPath,
  brandDeletePath,
  brandFindAllPageablePath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ModalForAddOrUpdateBrand } from '../enums/BrandEnums';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_BRAND,
  };
};

const addBrandStart = () => {
  return {
    type: ADD_BRAND_START,
  };
};
const addBrandSuccessfully = (data) => {
  return {
    type: ADD_BRAND,
    payload: data,
  };
};
const addBrandUnsuccessfully = (err) => {
  return {
    type: ADD_BRAND_ERROR,
    payload: err,
  };
};

const updateBrandStart = () => {
  return {
    type: UPDATE_BRAND_START,
  };
};
const updateBrandSuccessfully = (data) => {
  return {
    type: UPDATE_BRAND,
    payload: data,
  };
};
const updateBrandUnsuccessfully = (err) => {
  return {
    type: UPDATE_BRAND_ERROR,
    payload: err,
  };
};

const getBrandStart = () => {
  return {
    type: GET_BRAND_START,
  };
};
const getBrandSuccessfully = (data) => {
  return {
    type: GET_BRAND,
    payload: data,
  };
};
const getBrandUnsuccessfully = (err) => {
  return {
    type: GET_BRAND_ERROR,
    payload: err,
  };
};

const getBrandPageableListStart = () => {
  return {
    type: GET_BRAND_LIST_PAGEABLE_START,
  };
};

const getBrandPageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_BRAND_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getBrandListPageableUnsuccessfully = (err) => {
  return {
    type: GET_BRAND_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const deleteBrandStart = () => {
  return {
    type: DELETE_BRAND_START,
  };
};
const deleteBrandSuccessfully = (id) => {
  return {
    type: DELETE_BRAND,
    payload: id,
  };
};
const deleteBrandUnsuccessfully = (err) => {
  return {
    type: DELETE_BRAND_ERROR,
    payload: err,
  };
};

const getBrandListStart = () => {
  return {
    type: GET_BRAND_LIST_START,
  };
};
const getBrandListSuccessfully = (data) => {
  return {
    type: GET_BRAND_LIST,
    payload: data,
  };
};
const getBrandListUnsuccessfully = (err) => {
  return {
    type: GET_BRAND_LIST_ERROR,
    payload: err,
  };
};

export const createBrand = (brand, callback) => {
  return (dispatch) => {
    dispatch(addBrandStart());
    return apiService
      .post(brandAddPath(), brand)
      .then((response) => {
        dispatch(addBrandSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateBrand.saveSuccessMessage,
          brand
        );
        callback();
      })
      .catch((err) => {
        dispatch(addBrandUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateBrand = (brand, callback) => {
  return (dispatch) => {
    dispatch(updateBrandStart());
    return apiService
      .post(brandUpdatePath(), brand)
      .then((response) => {
        dispatch(updateBrandSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateBrand.updateSuccessMessage,
          brand
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateBrandUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findAllBrandsPageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getBrandPageableListStart());
    return apiService
      .get(brandFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getBrandPageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getBrandListPageableUnsuccessfully(err));
      });
  };
};

export const findBrandById = (id) => {
  return (dispatch) => {
    dispatch(getBrandStart());
    return apiService
      .get(brandFindByIdPath(id))
      .then((response) => {
        dispatch(getBrandSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getBrandUnsuccessfully(err));
      });
  };
};

export const deleteBrand = (id) => {
  return (dispatch) => {
    dispatch(deleteBrandStart());
    return apiService
      .delete(brandDeletePath(id))
      .then(() => {
        dispatch(deleteBrandSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateBrand.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteBrandUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorBrand = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllBrand = () => {
  return (dispatch) => {
    dispatch(getBrandListStart());
    return apiService
      .get(brandFindAllPath())
      .then((response) => {
        dispatch(getBrandListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getBrandListUnsuccessfully(err));
      });
  };
};
